import React from "react";
import styles from "./OnboardingStrategy.module.css";
import { cleanLines, stripBoldTitle, splitSentences } from "./utils";

const parseWhy = (md = "") => {
  const lines = stripBoldTitle(cleanLines(md));
  const body = lines.join(" ").trim();
  const sentences = splitSentences(body);
  return { body, sentences };
};

const WhyItMattersOnboarding = ({ markdown = "" }) => {
  const { body, sentences } = parseWhy(markdown);
  if (!body) return null;

  return (
    <div className={styles.container}>
      <h3 className={styles.heading}>Why It Matters</h3>
      <div className={styles.summaryCard}>
        <h4 className={styles.summaryTitle}>Key Insight</h4>
        {sentences.length > 1 ? (
          sentences.map((sentence, idx) => (
            <div key={idx} className={styles.bulletRow}>
              <span className={styles.bulletDot} />
              <span>{sentence}</span>
            </div>
          ))
        ) : (
          <p className={styles.summaryText}>{body}</p>
        )}
      </div>
      <div className={styles.impactCard}>
        <div className={styles.impactLabel}>Business Impact</div>
        <div className={styles.impactText}>
          Platform connectivity accelerates growth and enables data-driven decisions.
        </div>
      </div>
    </div>
  );
};

export default WhyItMattersOnboarding;
